'use strict';

let PENSION_MODULES_KEY = 'pensionModules';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('pensionModulesService', function($q, userStore, dispatcher, apiEndpointFactory) {
  return {
    fetchPensionModules: function() {
      var irn = userStore.getIrn();
      var endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/pension-modules',
        authRequired: true,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        return endpoint.get({expand: 'details'}).then(function(response) {
          let modules = response.data.modules;
          sessionStorage.setItem(PENSION_MODULES_KEY, JSON.stringify(modules));
          dispatcher.dispatch('pensionModulesService:modulesLoaded',
            modules);
        }, function(response) {
          return $q.reject(response.status);
        });
      } else {
        return $q.reject('IRN is undefined');
      }
    },
    pensionModulesPreload: function() {
      let modulesData = sessionStorage.getItem(PENSION_MODULES_KEY);
      if(modulesData){
        let modules = JSON.parse(modulesData);
        dispatcher.dispatch('pensionModulesService:modulesLoaded',
          modules);
        //return value in "cache" but still call pension modules to refresh
        this.fetchPensionModules();
        return $q.resolve();
      }

      return this.fetchPensionModules();


    }
  };
});
